import {
  AppBar,
  Chip,
  Dialog,
  Fade,
  IconButton,
  Paper,
  Slide,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { format } from 'date-fns';
import DemonstrativoApi from '../../api/DemonstrativoApi';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(2),
  },
  flex: {
    display: 'inline'
  },
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
  },
  tableCell: {
    maxWidth: 400,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 40,
  },
  invisible: {
    display: 'none',
  },
  chip: {
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
});

function Transition (props) {
  return <Slide direction='left' {...props} />;
}

class FullScreenDetalheArquivoBenner extends React.Component {
  demonstrativoApi = new DemonstrativoApi();

  state = {
    detalhesArquivo: [],
    fetching: true,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarDetalhesArquivo();
    this.setState({fetching: false});
  }
  consultarDetalhesArquivo = async () => {
    this.setState({detalhesArquivo: []});
    let detalhesArquivo = await this.demonstrativoApi.consultarDetalhesArquivo(this.props.codArquivo);
    this.setState({detalhesArquivo: detalhesArquivo});
  }
  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: 'none',
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
      }
    };
    const columns = [
      {
        name: 'codigo Arquivo',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Número do Demonstrativo',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Código da OB',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Número OB no Benner',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'CNPJ Origem Pagto.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'CNPJ Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },      
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Num. Nota Fiscal',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Emissão NF',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Liquidação',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Código Evento',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Desc. Evento',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Evento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography style={{fontSize: 12}}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
    ];

    const { classes, open, handleClose, nomeArquivo } = this.props;
    const { detalhesArquivo, fetching } = this.state;
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h6' color='inherit' className={classes.flex}>
                Arquivo - {nomeArquivo}
              </Typography>
              <Typography variant='h6' color='inherit' className={classes.flex}>
                {detalhesArquivo && <Chip label={detalhesArquivo.length + ' registro(s)'} className={classes.chip} />}
              </Typography>
            </Paper>
          </AppBar>
          {fetching ? <LinearProgressBlockScreen />
            : <Fade timeout={1000} in>
              <Paper className={classes.body} elevation={1}>
                <MUIDataTable
                  data={detalhesArquivo}
                  columns={columns}
                  options={options}
                />
              </Paper>
            </Fade>}
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(FullScreenDetalheArquivoBenner);
